import { Box, Typography, useTheme } from "@mui/material";

export default function About() {
  const theme = useTheme();
  return (
    <Box sx={{ px: 10, py: 4, bgcolor: theme.palette.custom.beige }}>
      <Typography
        variant="h5"
        sx={{ mb: 2, fontWeight: "bold" }}
        color={theme.palette.text.primary}
      >
        Supporting local youth leaders
      </Typography>
      <Typography
        variant="body1"
        sx={{ mb: 2, fontWeight: "bold" }}
        color={theme.palette.text.primary}
      >
        Crew 324 is a San Diego Venture crew founded in 2006 as part of the
        Scouting America program.
      </Typography>
      <Typography
        variant="body2"
        sx={{ mb: 2 }}
        color={theme.palette.text.primary}
      >
        We focus on high adventure, leadership development, and giving back to
        our community. We love to go skiing, whitewater rafting, rock climbing,
        learn outdoor and conservation skills, teach leadership and
        communication skills to our peers, and so much more!
      </Typography>
      <Typography
        variant="body1"
        sx={{ mb: 2, fontWeight: "bold" }}
        color={theme.palette.text.primary}
      >
        Why playhouses?
      </Typography>
      <Typography
        variant="body2"
        sx={{ mb: 2 }}
        color={theme.palette.text.primary}
      >
        Our scouts in the Crew wanted a way to fundraise for their high
        adventure activities—so we created adVenture playhouses. By purchasing
        this playhouse, not only do you get a fantastic fort for your family
        adventures, you’ll also be supporting us in ours!
      </Typography>
    </Box>
  );
}
